import React, {useState} from "react";
import {connect} from "react-redux";

import Acc from "../../plan/planitems/bmbox/Acc";
import Bm from "../../plan/planitems/bmbox/Bm";

import {hasBooster, hasDccgen} from "../bidib_commons";
import DccGen from "./DccGen";
import BoosterN from "./BoosterN";
import FoldingParagraph from "./FoldingParagraph";
import {send_fw_update} from "../../etc/cmd";

import {FeatureBox} from "./FeatureLine";
import {PropertyLine} from "./PropertyLine";

const NodeDetail = ({node, height}) => {
    const _node = node || { features: []}

    const [hover, setHover] = React.useState(false);
    //onMouseEnter={() => setHover(true)}
    //onMouseLeave={() => setHover(false)}

    const _width = 600

    const _minHeight = height
    const _maxHeight = _minHeight
    const _height = _minHeight

    const _uid = _node && _node.uid
    const _uidf = _node && _node.uid && `V${_node.uid.slice(4, 6)}P${_node.uid.slice(6)}`
    const _user = _node && _node.user && _node.user.replaceAll('http://', '').replace(/:[0-9]+/, '') || _uid
    const _prod = _node && _node.product
    const _title = `${_user || _uidf} (${_prod})` // + ` | ${node && node.path} | ${node && node.uid}`

    const _has_features = true
    const _has_bm = _node && _node.features && _node.features.FEATURE_BM_SIZE > 0 || false
    const _has_acc = _node && _node.features && _node.features.FEATURE_ACCESSORY_COUNT > 0 || false

    const _has_fwupdate = _node && _node.features && _node.features.FEATURE_FW_UPDATE_MODE > 0 || false

    const _has_dccgen = hasDccgen(_node.classid)
    const _has_booster = hasBooster(_node.classid)

    const _has_connection = node && node.onconnection

    return (
        <div>
            <div className="list listHeader" style={{
                width: _width,
            }}>
                {_title}
            </div>
            <div className="list listBody" style={{
                width: _width,

                height: _height,
                minHeight: _minHeight,
                maxHeight: _maxHeight,

                overflow: 'auto',

                color: '#bfbfbf', //hover ? '#e3e3e3' : '#bfbfbf',
            }}>

                <FoldingParagraph title={'Details'} closed={false}>
                    <PropertyLine key={_uid+"uid"} uid={_uid} keyname={'uid'} name={'UID'} value={node?.uid}/>
                    <PropertyLine key={_uid+"product"} uid={_uid} keyname={'product'} name={'Product'} value={node?.product}/>
                    <PropertyLine key={_uid+"name"} uid={_uid} keyname={'user'} name={'Name'} value={node?.user} readonly={false}/>
                    <PropertyLine key={_uid+"path"} uid={_uid} keyname={'path'} name={'Path'} value={node?.path}/>
                    <PropertyLine key={_uid+"version"} uid={_uid} keyname={'version'} name={'Version'} value={node?.version}/>
                    <PropertyLine key={_uid+"pversion"} uid={_uid} keyname={'pversion'} name={'Protocol'} value={node?.pversion}/>
                    {_has_connection &&
                        <PropertyLine key={_uid+"connection_peer"} uid={_uid} keyname={'connection_peer'} name={'Connection'} value={node?.connection_peer}/>
                    }
                </FoldingParagraph>

                {_has_dccgen &&
                    <FoldingParagraph title={'DCC'}>
                        <DccGen key={_node.uid} dccgenid={_node.uid}/>
                    </FoldingParagraph>}

                {_has_booster &&
                    <FoldingParagraph title={'Booster'}>
                        <BoosterN key={_node.uid} boosterid={_node.uid} node={_node}/>
                    </FoldingParagraph>}

                {_has_acc &&
                    <FoldingParagraph title={'Accessories'}>
                        <Acc nodeid={_node.uid} size={64}/>
                    </FoldingParagraph>}

                {_has_bm &&
                    <FoldingParagraph title={'BM'}>
                        <Bm nodeid={_node.uid} size={60}/>
                    </FoldingParagraph>}

                {_has_features &&
                    <FoldingParagraph title={'Features'} closed={true}>
                        <FeatureBox node={_node}/>
                    </FoldingParagraph>}

                {/* <div>
                    {_has_fwupdate && <div
                        style={{
                            cursor: 'pointer',
                        }}
                    >
                         <span onClick={() => {send_fw_update({id: node.uid})}}
                         >Update&nbsp;&nbsp;</span>
                        <span>{node && node?.fw_update && node.fw_update === 0xFF?"":`${node?.fw_update}%`}</span>
                    </div>}
                </div> */}

            </div>
        </div>
    )
}

function mapStateToProps(state, other) {
    let x = state.root.selected_node
    if (!x) {
        x = state.bidib.data.node && state.bidib.data.node.find(e => e.path === "0.0.0.0")
    }

    return {node: x, height: window.innerHeight - 150}
}

export default connect(mapStateToProps)(NodeDetail)
